import React from 'react';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

const StyledView = styled.View<ListItemAccessoryProps>`
  position: absolute;
  right: ${p => (p.extendedDivider ? 24 : p.framed ? 16 : 0)}px;
` as React.FC<ListItemAccessoryProps>;

export type ListItemAccessoryProps = ViewProps & {
  extendedDivider?: boolean;
  framed?: boolean;
};

const ListItemAccessory: React.FC<ListItemAccessoryProps> = ({
  extendedDivider,
  children,
  ...props
}) => {
  return (
    <StyledView extendedDivider={extendedDivider} {...props}>
      {children}
    </StyledView>
  );
};

export default ListItemAccessory;
